import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'yes_what_indoor_temperature_celsius_fac_continuously_maintains'

export const dataPointDefinition = {
  retracedId: 'yes_what_indoor_temperature_celsius_fac_continuously_maintains',
  name: 'If yes, what is the indoor temperature in Celsius the facility continuously maintains?',
  description:
    'Continuously maintains means that the facility has a system in place that regulates the temperature at a specifically designated level throughout the workday. There shall be no fluctuations/ changes in temperature in indoor environments. ',
  meta: {
    slcpMeta: {
      key: 'hs-gen-21',
      number: 'HS-GEN-7',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-gen-21', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31250,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
